/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Tournament_0_HeadingInputs */

const en_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leverage, not rebuild`)
};

const es_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovechar, no reconstruir`)
};

const de_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzen, nicht neu aufbauen`)
};

const zh_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`善用已有，而非推倒重来`)
};

const ar_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاستفادة، لا إعادة البناء`)
};

const fr_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirer parti, pas reconstruire`)
};

const vi_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tận dụng, không dựng lại`)
};

const sw_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumia ulicho nacho, usijenge upya`)
};

const th_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่อยอด ไม่ใช่รื้อสร้างใหม่`)
};

const bs_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iskoristi, ne gradi iznova`)
};

const ja_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作り直しではなく、活用する`)
};

const ko_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재구성이 아니라 활용`)
};

const pt_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveitar, não reconstruir`)
};

const it_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfruttare, non ricostruire`)
};

const sv_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utnyttja, bygg inte om`)
};

const nl_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutten, niet verbouwen`)
};

const da_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udnyt, byg ikke om`)
};

const nb_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utnytt, ikke bygg om`)
};

const fi_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyödynnä, älä rakenna uudelleen`)
};

const pl_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykorzystaj, nie przebudowuj`)
};

const ru_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опора на своё, а не перестройка`)
};

const tr_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden kurmayın, yararlanın`)
};

const hi_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोबारा बनाना नहीं, लाभ उठाना`)
};

const id_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manfaatkan, bukan bangun ulang`)
};

const ms_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manfaatkan, bukan bina semula`)
};

const cs_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Využijte, nepřestavujte`)
};

const el_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αξιοποίηση, όχι ανακατασκευή`)
};

const he_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למנף, לא לבנות מחדש`)
};

const af_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benut, moenie herbou nie`)
};

const hu_method_content_step_02_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiaknázás, nem újjáépítés`)
};

/**
* | output |
* | --- |
* | "Leverage, not rebuild" |
*
* @param {Method_Content_Step_02_Detail_Tournament_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_tournament_0_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Tournament_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Tournament_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_tournament_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_tournament_0_heading(inputs)
	return en_method_content_step_02_detail_tournament_0_heading(inputs)
});